import { defineMessage } from 'react-intl'

export const LAST_MINUTE_PRODUCT_NAME_MESSAGE = defineMessage({
  id: 'OvhJL8LPC71fG6yAeSWv',
  defaultMessage: 'Last Minute Escapes',
  description: 'Alternative text for the Last Minute Escapes badge image shown on offer cards and map info windows',
})
export const LAST_MINUTE_PRODUCT_CODE = 'lastMinute'
export const LAST_MINUTE_LABEL_ID = '2ne0nnfbal87aj5cs98n'
